import { 
    LOADING, 
    GET_BENEFITS,
    SAVE_BENEFIT,
    CACHE_BENEFIT,
    CLEAN_BENEFIT,
    UPDATE_BENEFIT,
    DELETE_BENEFIT
 } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
    switch (action.type) {
            case GET_BENEFITS:               
                return {
                ...state,
                benefits: action.payload
            }
            case CACHE_BENEFIT:               
                return {
                    ...state,
                    benefit: action.payload
            }
            case CLEAN_BENEFIT:
                return {
                    ...state,
                    benefit: {}
            }
            case SAVE_BENEFIT:               
                return {
                ...state,
                benefits: [...state.benefits, action.payload]
            }
            case UPDATE_BENEFIT:  
            return {
                ...state,
                benefits: state.benefits.map(benefit => {
                    if(benefit.id === action.payload.id){return action.payload;}
                    else{return benefit;}
                })
            }             
            case DELETE_BENEFIT:               
                return {
                ...state,
                benefits: state.benefits.filter(benefit => benefit.id !== action.payload)
            }
           case LOADING:               
               return {
                   ...state,
                   loading: !state.loading
               }
        default:
            return state;
    }
}